<template>
  <div class="main-nav_section">
    <ul class="nav-list">
      <NavLink
        :path="`/${activeWorkspaceUUID}`"
        label="Home"
        icon="icon-home"
      ></NavLink>

      <NavLinkGroup
        label="My Conversations"
        icon="icon-chat"
        :alwaysOpen="true"
      >
        <NavLink
          :path="`/${activeWorkspaceUUID}/conversations`"
          label="Conversations"
          icon="icon-conversation"
        ></NavLink>
        <NavLink
          :path="`/${activeWorkspaceUUID}/favorites`"
          label="Favorites"
          icon="icon-heart"
        ></NavLink>
      </NavLinkGroup>
    </ul>
  </div>
</template>

<script>
import { useWorkSpaceStore } from "@/stores/workspace-store";
import NavLink from "./NavLink.vue";
import NavLinkGroup from "./NavLinkGroup.vue";

export default {
  name: "NavLinks",
  components: { NavLink, NavLinkGroup },
  computed: {
    activeWorkspaceUUID() {
      const store = useWorkSpaceStore();
      return store.activeWorkspaceUUID;
    },
  },
};
</script>
